<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							<b-tab title="Upload Stock Opname Result" active>

                                <b-row v-if="hasFailedDataStockOpnameResult">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedStockOpnameResult.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="stockOpnameResultsFailed" :fields="fieldsStockOpnameResult" :busy="isDataLoading"
                                                         :sort-by.sync="sortByStockOpnameResult" :sort-desc.sync="sortDescStockOpnameResult" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
													<template #cell(qtyActual)="row">
														{{ Number(row.item.qtyActual).toLocaleString() }}
													</template>
													<template #cell(tanggalSto)="row">
														{{ row.item.tanggalSto | moment("DD-MMM-YYYY") }}
													</template>
                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedStockOpnameResult.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="stockOpnameResults" :fields="fieldsStockOpnameResult" :busy="isDataLoading"
                                                         :sort-by.sync="sortByStockOpnameResult" :sort-desc.sync="sortDescStockOpnameResult" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
													<template #cell(qtyActual)="row">
														{{ Number(row.item.qtyActual).toLocaleString() }}
													</template>
													<template #cell(tanggalSto)="row">
														{{ row.item.tanggalSto | moment("DD-MMM-YYYY") }}
													</template>
                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>
                            </b-tab>
						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import StockOpnameResult from '@/models/StockOpnameResult/StockOpnameResult';
import StockOpnameResultList from '@/models/StockOpnameResult/StockOpnameResultList';
import StockOpnameResultFilter from '@/filters/StockOpnameResult/StockOpnameResultFilter';

import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsStockOpnameResult: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Vendor Subcontract Code", key: 'vendorSubcontractCode', sortable: false},
				{"class" : "th-status", "label" : "Tanggal STO", key: 'tanggalSto', sortable: false},
				{"class" : "th-status", "label" : "Case Number", key: 'caseNumber', sortable: false},
				{"class" : "th-message", "label" : "Part No", key: 'partNumber', sortable: false},
				{"class" : "th-status", "label" : "Qty Actual", key: 'qtyActual', sortable: false},
				{"class" : "th-status", "label" : "ID Card (PIC STO)", key: 'idCard', sortable: false},
				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsStockOpnameResultDetail: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Control Card", key: 'controlCardControlCardNumber', sortable: false},
				{"class" : "th-status", "label" : "Qty System", key: 'qtySystem', sortable: false},
				{"class" : "th-status", "label" : "Total Price Qty System", key: 'totalPriceQtySystem', sortable: false},
				{"class" : "th-status", "label" : "Qty Actual", key: 'qtyActual', sortable: false},
				{"class" : "th-status", "label" : "Total Price Qty Actual", key: 'totalPriceQtyActual', sortable: false},
				{"class" : "th-status", "label" : "Total Difference Qty", key: 'totalDifferenceQty', sortable: false},
				{"class" : "th-status", "label" : "Total Difference Price", key: 'totalDifferencePrice', sortable: false},
				{"class" : "th-status", "label" : "Difference Percentage", key: 'differenctPercentage', sortable: false},
				{"class" : "th-status", "label" : "Scanned Date", key: 'scannedDate', sortable: false},
				{"class" : "th-status", "label" : "Scanned By", key: 'scannedByFirstName', sortable: false},
				{"class" : "th-status", "label" : "Stock Opname Detail", key: 'stockOpnameDetailControlCard', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			stockOpnameResults : [],
			stockOpnameResultsFailed: [],
			stockOpnameResultId : '',
			sortByStockOpnameResult: '',
			sortDescStockOpnameResult: '',
			hasFailedDataStockOpnameResult: false,
			totalFailedStockOpnameResult: 0,
			totalSucceedStockOpnameResult: 0,
			stockOpnameResultDetails : [],
			stockOpnameResultDetailsFailed: [],
			stockOpnameResultDetailId : '',
			sortByStockOpnameResultDetail: '',
			sortDescStockOpnameResultDetail: '',
			hasFailedDataStockOpnameResultDetail: false,
			totalFailedStockOpnameResultDetail: 0,
			totalSucceedStockOpnameResultDetail: 0,


			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.totalSucceedStockOpnameResult = 0;
			this.stockOpnameResultsFailed = [];
			this.totalFailedStockOpnameResult= 0;
			this.stockOpnameResults = [],
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
			let _this = this;
				this.$http.post('stockopnameresult/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('stockopnameresult/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getStockOpnameResultForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getStockOpnameResultForUpload : async function() {
			let _this = this;
			this.$http.get('stockopnameresult/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.stockOpnameResults = [];
                    _this.totalSucceedStockOpnameResult = 0;
					if (response != null) {
						let result = response.data;
						_this.stockOpnameResults = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedStockOpnameResult = _this.stockOpnameResults.length;

						_this.stockOpnameResultsFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataStockOpnameResult = true;
						_this.totalFailedStockOpnameResult = 0;
						if(_this.stockOpnameResultsFailed == undefined || _this.stockOpnameResultsFailed.length === 0) _this.hasFailedDataStockOpnameResult = false;
						if(_this.hasFailedDataStockOpnameResult) _this.totalFailedStockOpnameResult = _this.stockOpnameResultsFailed.length;
						
						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'stockopnameresult/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'StockOpnameResult.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterStockOpnameResult = new StockOpnameResultFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
